import _extends from "@babel/runtime-corejs2/helpers/extends";
import _objectWithoutProperties from "@babel/runtime-corejs2/helpers/objectWithoutProperties";
var _excluded = ["title"];
import * as React from 'react';
export default (function (_ref) {
  var title = _ref.title,
    extra = _objectWithoutProperties(_ref, _excluded);
  return (
    /*#__PURE__*/
    // $FlowFixMe[cannot-spread-inexact]
    React.createElement("svg", _extends({
      height: "50",
      width: "50",
      viewBox: "0 0 50 50"
    }, extra), title, /*#__PURE__*/React.createElement("path", {
      d: "M25,0 C38.77,0 50,11.23 50,25 C50,38.77 38.77,50 25,50 C9.552,50 0,37.042 0,25 C0,11.23 11.23,0 25,0 Z M24.998,3 C12.882,3 2.998,12.88 2.998,25 C2.998,35.598 11.406,47 24.998,47 C37.118,47 46.998,37.118 46.998,25 C46.998,12.88 37.118,3 24.998,3 Z M26.778,31.096 L26.778,34.656 L23.222,34.656 L23.222,31.096 L26.778,31.096 Z M26.778,15.346 L26.778,28.202 L23.222,28.202 L23.222,15.346 L26.778,15.346 Z"
    }))
  );
});